import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Tabs, Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import 'antd/dist/antd.css';

const { Title } = Typography;
const { TabPane } = Tabs;

@inject("bookingStore")
@observer
class AdminBookingListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.bookingStore.initAdminBooking();
    }

    // TABLE SETTINGS

    getColumns = () => {
        return [
            {
                title: 'Booking Event',
                dataIndex: 'bookingEvent',
                key: 'bookingEvent',
                ...this.getColumnSearchProps('bookingEvent')
            },
            {
                title: 'Room Number',
                dataIndex: 'roomNo',
                key: 'roomNo',
                ...this.getColumnSearchProps('roomNo')
            }
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    })

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex
        })
    }

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    // ON CHANGE

    bookingTabOnChange = () => {
        this.props.bookingStore.initAdminBooking();
    }

    render() {
        const { bookings, adminBookingLoading } = this.props.bookingStore;

        const todoBookings = bookings.filter(fi => fi.stateCode === 0);
        const doingBookings = bookings.filter(fi => fi.stateCode === 1);
        const doneBookings = bookings.filter(fi => fi.stateCode === 2);

        return (
            <React.Fragment>
                <Title level={3}>Booking List</Title>

                <Tabs defaultActiveKey="1" onChange={this.bookingTabOnChange}>
                    <TabPane tab="To Do" key="1">
                        <Spin spinning={adminBookingLoading}>
                            <Form layout="horizontal">
                                <Table columns={this.getColumns()} dataSource={todoBookings} />
                            </Form>
                        </Spin>
                    </TabPane>
                    <TabPane tab="Doing" key="2">
                        <Spin spinning={adminBookingLoading}>
                            <Form layout="horizontal">
                                <Table columns={this.getColumns()} dataSource={doingBookings} />
                            </Form>
                        </Spin>
                    </TabPane>
                    <TabPane tab="Done" key="3">
                        <Spin spinning={adminBookingLoading}>
                            <Form layout="horizontal">
                                <Table columns={this.getColumns()} dataSource={doneBookings} />
                            </Form>
                        </Spin>
                    </TabPane>
                </Tabs>
            </React.Fragment>
        )
    }
}

export default AdminBookingListPage